var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_265908868470706295658817786489582897935",
    d: "M22 9v5c0 4.418-3.582 8-8 8h-1v2c0 1.105-.895 2-2 2s-2-.895-2-2v-2H8c-4.418 0-8-3.582-8-8V9h22zM3 7V2c0-1.105.895-2 2-2s2 .895 2 2v5H3zm12-5c0-1.105.895-2 2-2s2 .895 2 2v5h-4V2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_113925157669967832085519884994363324598",
    d: "M-5 -3H27V29H-5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_71041563503322731283263826960116594009",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_41207337302124151635283476236983568835",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_265908868470706295658817786489582897935"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_265908868470706295658817786489582897935"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_41207337302124151635283476236983568835)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_113925157669967832085519884994363324598"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_71041563503322731283263826960116594009)",
    xlinkHref: "#hinava_random_uuid_113925157669967832085519884994363324598"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.428bc8591103b5dc509c56e5d6412949.svg";
export { ForwardRef as ReactComponent };